<template>
  <section class="jobs">
    <companies-nav :active="activeCompaniesNav" v-on:active="onActiveCompaniesNav"
              :keyword.sync="keyword" v-on:location="onLocationChanged"
              v-on:enter="onEnterPressed">
    </companies-nav>
    <columns :is-multiline="true" v-if="companies.length > 0 && !companiesLoading">
      <column size="is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd" v-for="company in companies" :key="company.id">
        <company-card-widget :isCompanyPage="true" :company="company"></company-card-widget>
      </column>
    </columns>
    <jobs-skeleton v-else-if="companiesLoading"  :companies="true" ></jobs-skeleton>
    <empty-state v-else  :title="this.$t('jobs.noCompanies')" icon="empty-state-company">
      <template slot="content">
        <p class="text">{{this.$t('jobs.noCompaniesDesc')}}</p>
      </template>
    </empty-state>
  </section>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Heading from '@/components/general/heading'
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import CompaniesNav from './nav'
import JobCard from '../jobs/job-card'
import EmptyState from '@/components/general/empty-state'
import JobsSkeleton from '@/components/jobs/jobs-skeleton'
import CompanyCardWidget from '../jobs/company-card-widget'

export default {
  name: 'CompaniesList',
  components: {
    CompaniesNav,
    JobCard,
    Heading,
    Columns,
    Column,
    EmptyState,
    JobsSkeleton,
    CompanyCardWidget
  },
  props: {
    companies: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      activeJobNav: 'all',
      keyword: '',
      timer: null,
      location: 'Anywhere',
      activeCompaniesNav: 'all'
    }
  },
  computed: {
    ...mapState('companies', ['companiesLoading'])
  },
  watch: {
    activeCompaniesNav (newVal, oldVal) {
      if (newVal === null) {
        return
      }
      if (newVal !== oldVal) {
        this.updateJobs()
      }
    },
    keyword (value) {
      if (value === '') { return this.onEnterPressed() }
      window.clearTimeout(this.timer)

      this.timer = window.setTimeout(() => {
        this.updateJobs()
      }, 500)
    }
  },
  methods: {
    ...mapActions('jobs', [
      'getJobs',
      'getHiredJobs',
      'getAppliedJobs',
      'search'
    ]),
    onEnterPressed () {
      window.clearTimeout(this.timer)
      this.updateJobs()
    },
    onActiveCompaniesNav (active) {
      this.activeCompaniesNav = active
    },
    onLocationChanged (value) {
      this.location = value
      this.updateJobs()
    },
    updateJobs () {
      if (this.activeCompaniesNav === 'all') {
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.jobs {
  .list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    li {
      flex-basis: 20rem;
      margin-bottom: 1rem;
      border: 1px solid #ddd;
      background-color: #fff;
      margin-right: 1rem;
      border-radius: .5rem;
    }
  }
}

h2.heading {
  margin-bottom: 16px;
}

.column {
  padding: 0.5rem;
}

.column {
  margin-bottom: 2px;
}

@media (max-width:480px)  {
  .jobs .list > li {
    flex-grow: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/companies/companies-list.vue